import React from "react";
import { portfolioData } from "../data/portfolioData";

const Footer = () => {
  return (
    <footer className="border-t border-slate-700/70 bg-slate-950/70 py-6 text-sm text-slate-400">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 sm:flex-row">
        <p>
          Copyright {new Date().getFullYear()} {portfolioData.name}
        </p>
        <a
          href={portfolioData.linkedin}
          target="_blank"
          rel="noreferrer"
          className="text-cyan-300 transition hover:text-cyan-200"
        >
          LinkedIn
        </a>
      </div>
    </footer>
  );
};

export default Footer;
